import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: ${props => props.theme.fonts.primary};
    background-color: ${props => props.theme.colors.background};
    color: ${props => props.theme.colors.textPrimary};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: ${props => props.theme.fontWeights.semibold};
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: ${props => props.theme.fontSizes.xxxl};
  }

  h2 {
    font-size: ${props => props.theme.fontSizes.xxl};
  }

  h3 {
    font-size: ${props => props.theme.fontSizes.xl};
  }

  h4 {
    font-size: ${props => props.theme.fontSizes.lg};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: ${props => props.theme.transitions.fast};

    &:hover {
      color: ${props => props.theme.colors.primaryDark};
    }
  }

  button {
    font-family: ${props => props.theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
    transition: ${props => props.theme.transitions.fast};
  }

  input, textarea, select {
    font-family: ${props => props.theme.fonts.primary};
    outline: none;
  }

  ul, ol {
    list-style: none;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  /* Scrollbar styles */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.backgroundLight};
  }

  ::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.border};
    border-radius: ${props => props.theme.borderRadius.sm};

    &:hover {
      background: ${props => props.theme.colors.secondary};
    }
  }

  /* Print styles */
  @media print {
    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }

    body {
      background-color: white !important;
      color: black !important;
      margin: 0 !important;
      padding: 0 !important;
    }

    /* Ocultar elementos de navegación */
    header,
    nav,
    .sidebar,
    .no-print,
    button:not(.print-visible),
    .action-buttons {
      display: none !important;
    }

    /* Ocultar scrollbars en impresión */
    ::-webkit-scrollbar {
      display: none !important;
    }

    /* Optimizar para impresión */
    .print-content {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 20px !important;
      box-shadow: none !important;
    }

    /* Evitar saltos de página en elementos */
    h1, h2, h3, h4, h5, h6 {
      page-break-after: avoid !important;
    }

    table, img, figure {
      page-break-inside: avoid !important;
    }

    /* Ajustar márgenes de página */
    @page {
      margin: 1cm;
      size: letter;
    }
  }
`;
